import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddAttendance.module.scss";
import { Formik } from "formik";
import addAttendanceSchema from "./addSession.schema";
import { RequiredFieldAstrick } from "components/Common/Common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useAddAttendanceMutation } from "store/services/clients/attendance";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { successMessageToast } from "helpers/common";


const AddAttendancePop = ({ show, setShow, clientId, refetch }) => {

    const handlePopup = () => setShow(!show);

    const [addAttendance, { isLoading }] = useAddAttendanceMutation();

    const handleSubmit = async (values) => {

        try {

            setShow(false);
            const result = await addAttendance({ clientId, data: values });
            if (!result.error) {
                successMessageToast(result?.data?.message);
                refetch();
            }

        } catch (err) { console.log("error adding attendance"); };
    };

    return (
        <>
            {isLoading && <LoadingOverlay />}
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded px-4`}>
                    <div>
                        <h4 className="m-0 fw-bold themeBlue">Add Session Attendance</h4>

                    </div>
                    <Formik
                        initialValues={{ session_date: "", attendance: "present" }}
                        validationSchema={addAttendanceSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row >
                                    <Col md="6" sm="6" className="my-3">
                                        <label
                                            htmlFor=""
                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                            Session Date
                                            <RequiredFieldAstrick />
                                        </label>
                                        <AppDatePicker
                                            name="session_date"
                                            placeholder="e.g John"
                                            className={`${styles.formControl} form-control`}
                                            maxLength={30}
                                            portalId={"root"}
                                            autocomplete="off"
                                        />
                                    </Col>
                                    <Col md="6" sm="6" className="my-3">
                                        <label
                                            htmlFor=""
                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                            Attendance
                                            <RequiredFieldAstrick />
                                        </label>
                                        <div class="main-attendance-fields">
                                            <div class="inner-attendance-fields">
                                                <label class="present-absent">Present
                                                    <input
                                                        type="radio"
                                                        checked={values.attendance == "present"}
                                                        name="attendance"
                                                        value={"present"}
                                                        onChange={handleChange}
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="present-absent">Absent
                                                    <input
                                                        type="radio"
                                                        name="attendance"
                                                        value={"absent"}
                                                        checked={values.attendance == "absent"}
                                                        onChange={handleChange}
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md="12" sm="12" className="mt-2">
                                        <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                                            <Button
                                                type="submit"
                                                className="w-100 btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                            >
                                                Save

                                            </Button>
                                            <h5
                                                role="button"
                                                className="my-3 text-muted"
                                                onClick={() => setShow(false)}
                                            >
                                                Cancel
                                            </h5>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddAttendancePop;
